import React, { PropsWithChildren, Attributes } from 'react';

export const enhanceChildrenProps = function <T>(
    parentProps: PropsWithChildren<T>,
    enhancingPropsFunc: (originalProps: Partial<any> & Attributes) => Partial<any> & Attributes
): React.ReactElement<any>[] {
    const { children } = parentProps;
    const childrenArray = React.Children.toArray(children);
    const newChildren = childrenArray
        .filter((node) => React.isValidElement(node))
        .map((node) => {
            const element = node;
            const newProps = enhancingPropsFunc(element.props);
            //eslint-disable-next-line
            return React.cloneElement(element, {...newProps});
        });

    return newChildren;
};
